import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

export default function FormSkeleton() {
  return (
    <Stack spacing={4} width="100%">
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={4}>
        <Stack spacing={0.9} sx={{ flex: 0.85, pr: 3 }}>
          <Skeleton variant="rounded" width={867} height={43} />
          <Skeleton variant="rounded" width={867} height={43} />
          <Stack direction="column" spacing={1}>
            <Skeleton variant="rounded" width={140} height={43} />
            <Stack sx={{ pl: 4 }}>
              <Skeleton variant="rounded" width={835} height={20} />
            </Stack>
          </Stack>
          <Stack direction="column" spacing={1}>
            <Skeleton variant="rounded" width={200} height={28} />
            <Skeleton variant="rounded" width={867} height={43} />
            <Skeleton variant="rounded" width={150} height={20} />
          </Stack>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              mt: 2,
              pr: 4,
            }}
          >
            <Skeleton variant="rounded" width={200} height={20} />
          </Box>
        </Stack>
      </Stack>
    </Stack>
  );
}
